(function (window, document, $) {
    "use strict";

    var app;
    var onready;
    var onload;
    var $w = $(window);
    var $d = $(document);
    var $b = $(document.body);
    var $header = $(document.getElementById("header"));
    var $content = $(document.getElementById("content"));
    var $footer = $(document.getElementById("footer"));

    app = {
        vars: {},
        jrespond: (function () {
            var css = $("head").css("font-family").replace(/^"?|"?$|\\/g, "").split(","),
                bps = [],
                bp,
                i;

            for (i = 0; i < css.length; i += 1) {
                bp = css[i].trim().split(' ');
                bps.push({
                    label: bp[0],
                    enter: parseInt(bp[1], 10),
                    exit: parseInt(bp[2], 10)
                });
            }

            return jRespond(bps);
        }()),
        cookie: (function () {
            var set = function (name, value, options) {
                    options = options || {};

                    return document.cookie = [
                        name + "=" + encodeURIComponent(value),
                        options.expires ? "; expires=" + new Date(new Date().getTime() + (options.expires * 24 * 60 * 60 * 1000)).toUTCString() : "",
                        options.path ? "; path=" + options.path : ""
                    ].join("");
                },
                map = function () {
                    var map_cookies = {},
                        cookies = document.cookie.split('; '),
                        cookie,
                        i;

                    for (i = 0; i < cookies.length; i += 1) {
                        cookie = cookies[i].split('=');
                        map_cookies[cookie[0]] = decodeURIComponent(cookie[1]);
                    }

                    return map_cookies;
                },
                get = function (name) {
                    return this.map()[name];
                },
                remove = function (name, options) {
                    return this.set(name, '', $.extend({}, options, {expires: -1}));
                };

            return {
                set: set,
                map: map,
                get: get,
                remove: remove
            };
        }()),
        scrollto: (function () {
            var $__anchors = $("[data-anchor]"),
                hash = window.location.hash;

            function scrollto(el, offset) {
                var target,
                    $target;

                if (el.target) {
                    if ($(el.target).data("scrollto") !== undefined) {
                        target = $(el.target).data("scrollto");
                    } else if (el.target.pathname && el.target.hostname && window.location.pathname.replace(/^\//, "") === el.target.pathname.replace(/^\//, "") && window.location.hostname === el.target.hostname) {
                        target = el.target.hash;
                    }
                } else {
                    target = el;
                }

                if ($(target).length) {
                    $target = $(target);
                } else if ($("[data-anchor='" + target + "']").length) {
                    $target = $("[data-anchor='" + target + "']");
                }
                if (!target || !$target || !$target.length) {
                    return;
                }

                offset = offset || 0;
                if ($target.data("scrollto-offset") !== undefined) {
                    offset += parseInt($target.data("scrollto-offset"), 10);
                } else if (el.target && $(el.target).data("scrollto-offset") !== undefined) {
                    offset += parseInt($(el.target).data("scrollto-offset"), 10);
                }
                if (['xs', 'sm', 'md'].indexOf(app.jrespond.getBreakpoint()) !== -1 || $w.scrollTop() >= $target.offset().top) {
                    offset += parseInt($(".head__bar", $header).css("min-height"), 10);
                }

                if (window.scroll) {
                    window.scroll({
                        top: $target.offset().top - offset,
                        left: 0,
                        behavior: 'smooth'
                    });
                } else {
                    $("body, html").animate({
                        scrollTop: $target.offset().top - offset
                    }, 500);
                }

                return true;
            }

            $d.on("click.scrollto scrollto", "[data-scrollto], a[href*='#']:not([href$='#'])", function (e) {
                if ($(this).hasClass("js-expanded")) {
                    return;
                }
                if (scrollto(e)) {
                    e.preventDefault();
                }
            });
            $d.on("anchor", "[data-anchor]", function () {
                if ($(this).data("anchor") !== undefined) {
                    scrollto(this);
                }
            });
            $w.on("load", function () {
                if (hash && $__anchors.length) {
                    $__anchors.each(function () {
                        if ($(this).attr("data-anchor") === hash) {
                            $(this).trigger("anchor");
                        }
                    });
                }
            });

            return scrollto;
        }()),
        debounce: function (fn, threshold) {
            var timeout;

            return function () {
                var that = this,
                    args = arguments;

                clearTimeout(timeout);

                timeout = setTimeout(function () {
                    fn.apply(that, args);
                }, threshold || 100);
            };
        },
        before: function () {
            app.vars.switch = {};

            $d.on("switch switch:open switch:close", function (e, data) {
                var params = {
                    target: document.body,
                    type: e.type.replace("switch:", "")
                };

                if (typeof data === "object") {
                    $.extend(params, data);
                } else {
                    params.name = data;
                }

                params.class = params.name + "--open";
                params.open = !app.vars.switch[params.name];

                $d.trigger({
                    type: "switch:before",
                    namespace: params.namespace ? params.namespace : params.name,
                    switch: params,
                    target: e.target
                });

                switch (params.type) {
                    case "open":
                        $(params.target).addClass(params.class);
                        break;
                    case "close":
                        $(params.target).removeClass(params.class);
                        break;
                    default:
                        $(params.target).toggleClass(params.class);
                }

                app.vars.switch[params.name] = $(params.target).hasClass(params.class);
                params.open = !!app.vars.switch[params.name];

                $d.trigger({
                    type: "switch:after",
                    namespace: params.name,
                    switch: params,
                    target: e.target
                });
            });

            $d.on("click.switch", "[data-switch]", function (e) {
                var data = $(this).data("switch");
                var params = {
                    prevent: true
                };

                if (typeof data === "string") {
                    params.name = data;
                } else {
                    $.extend(params, data);
                }

                if (params.prevent) {
                    e.preventDefault();
                }
                delete params.prevent;

                $d.trigger({
                    type: "switch",
                    target: this
                }, params);
            });

            window.addEventListener("beforeunload", function (e) {
                if (app.vars.sending) {
                    e.returnValue = "";
                    e.preventDefault();
                }
            });

            $d.on("click.expanded", ".js-expanded", function (e) {
                var $target;

                if (this.hash) {
                    $target = $(this.hash);
                }
                if ($target && $target.length) {
                    $target.addClass("expanded");
                    app.scrollto($target);
                }

                e.preventDefault();
            });
        },
        after: function () {
            if (typeof $.fn.parallax === "function") {
                $(".js-parallax").parallax();
            }
        },
        swiper: (function () {
            var defaults = {
                // initialSlide: 0,
                // direction: "horizontal",
                speed: 1000,
                // virtualTranslate: false,
                // autoHeight: false,
                // roundLengths: false,
                // nested: false,
                effect: "fade",
                fadeEffect: {
                    crossFade: true
                },
                // spaceBetween: 0,
                // slidesPerView: 1,
                // slidesPerColumn: 1,
                // slidesPerColumnFill: 'column',
                // slidesPerGroup: 1,
                // centeredSlides: false,
                // slidesOffsetBefore: false,
                // slidesOffsetAfter: false,
                // normalizeSlideIndex: true,
                grabCursor: true,
                // touchRatio: 1,
                // touchAngle: 45,
                // simulateTouch: true,
                // shortSwipes: true,
                // longSwipes: true,
                // longSwipesRatio: 0.5,
                // longSwipesMs: 300,
                // followFinger: true,
                // allowTouchMove: true,
                // threshold: 0,
                // touchMoveStopPropagation: true,
                // touchReleaseOnEdges: false,
                // passiveListeners: true,
                // resistance: true,
                // resistanceRatio: 0.85,
                // preventClicks: true,
                // preventClicksPropagation: true,
                // slideToClickedSlide: false,
                // watchSlidesProgress: false,
                // watchSlidesVisibility: false,
                loop: true,
                // loopAdditionalSlides: 0,

                play: false,
                hash: false,
                pager: false,
                buttons: false,
                external: false,
                keyboard: false,
                progressbar: false
            };

            function paginationToggle(s) {
                if (!s.options.pager || !s.options.pagination.el.length) {
                    return;
                }

                if ((s.obj.params.slidesPerView !== "auto" && s.obj.slides.length > s.obj.params.slidesPerView) || (s.obj.params.slidesPerView === "auto" && s.obj.width < s.obj.virtualSize)) {
                    s.options.pagination.el.show();
                } else {
                    s.options.pagination.el.hide();
                }
            }

            function slideTo(s, hash) {
                if (s.hash.indexOf(hash) > -1) {
                    s.obj.slideTo($(".swiper-slide[data-hash='" + hash + "']", s.cont).index());
                }
            }

            return {
                init: function (el) {
                    var swiper = {
                        cont: $(".swiper-container", el)[0],
                        hash: []
                    };

                    if (!el || !$(el).length || typeof Swiper !== "function") {
                        return false;
                    } else if (swiper.cont.swiper) {
                        return swiper.cont.swiper;
                    }

                    swiper.data = $(swiper.cont).data("swiper-options") || {};
                    swiper.options = $.extend(true, {}, defaults, swiper.data);

                    if (swiper.options.play) {
                        swiper.options.autoplay = {
                            delay: swiper.options.play,
                            // stopOnLast: false,
                            disableOnInteraction: false,
                            pauseOnHover: true
                        };
                    }
                    if (swiper.options.hash) {
                        swiper.options.hashNavigation = {
                            watchState: true,
                            replaceState: true
                        };
                    }
                    if (swiper.options.pager) {
                        swiper.options.pagination = {
                            el: $(".swiper-pagination", el),
                            clickable: true
                        };
                        if (["bullets", "fraction"].indexOf(swiper.options.pager) >= 0) {
                            swiper.options.pagination.type = swiper.options.pager;
                        }
                        swiper.options.pagination.el[$(".swiper-slide", el).length === 1 ? "hide" : "show"]();
                    }
                    if (swiper.options.buttons) {
                        swiper.options.navigation = {
                            prevEl: $(".swiper-button-prev", el)[0],
                            nextEl: $(".swiper-button-next", el)[0]
                        };
                        $(".swiper-buttons", el).show();
                    }

                    $(".swiper-wrapper", el).children().addClass("swiper-slide");

                    swiper.obj = new Swiper(swiper.cont, swiper.options);

                    if (swiper.options.play && swiper.options.autoplay.delay && swiper.options.autoplay.delay > 0 && swiper.options.autoplay.pauseOnHover) {
                        $(swiper.cont).on({
                            "mouseenter.swiper": swiper.obj.autoplay.stop,
                            "mouseleave.swiper": swiper.obj.autoplay.start
                        });
                    }

                    $w.on("resize.swiper-resize", function () {
                        paginationToggle(swiper);
                    });

                    if (swiper.options.external && $(swiper.options.external).length) {
                        $(".swiper-slide", el).map(function () {
                            if ($(this).attr("data-hash") !== undefined) {
                                swiper.hash.push($(this).attr("data-hash"));
                            }
                        });
                        swiper.obj.on("transitionStart", function () {
                            $("a[href^='#" + $(".swiper-slide", el).eq(swiper.obj.activeIndex).attr("data-hash") + "']", swiper.options.external)
                                .parent("li")
                                .addClass("active")
                                .siblings("li")
                                .removeClass("active");
                        });
                        $(".swiper-slide", el).on("onScrollTo", function () {
                            slideTo(swiper, $(this).attr("data-hash"));
                        });
                        if (window.location.hash && $("a[href='" + window.location.hash + "']", swiper.options.external).length) {
                            slideTo(swiper, window.location.hash.slice(1));
                        }
                        $w.on("hashchange", function () {
                            slideTo(swiper, window.location.hash.slice(1));
                        });
                    }

                    $(el)
                        .data("swiper", swiper.obj)
                        .on("update", function () {
                            swiper.obj.update();
                            swiper.obj.slideTo(0, 0);
                        });

                    return swiper.obj;
                },
                onready: function () {
                    var $swiper = $(".swiper");

                    if (!$swiper.length) {
                        return;
                    }

                    $swiper.each(function () {
                        app.swiper.init(this);
                    });
                }
            };
        }()),
        lightbox: (function () {
            var galleries = {};

            return {
                setup: (function () {
                    if (typeof $.magnificPopup !== "object") {
                        return;
                    }

                    $.extend(true, $.magnificPopup.defaults, {
                        tClose: translations.close,
                        closeMarkup: '<button type="button" title="%title%" class="mfp-close btn-close"></button>',
                        tLoading: translations.loading,
                        gallery: {
                            tPrev: translations.previous,
                            tNext: translations.next,
                            tCounter: "%curr% " + translations.of + " %total%",
                            arrowMarkup: '<button type="button" title="%title%" class="mfp-arrow mfp-arrow-%dir% btn-%dir%"></button>'
                        },
                        image: {
                            tError: "<a href=\"%url%\">" + translations.popup_the_image + "</a> " + translations.popup_could_not_be_loaded + "."
                        },
                        ajax: {
                            tError: "<a href=\"%url%\">" + translations.popup_the_content + "</a> " + translations.popup_could_not_be_loaded + "."
                        }
                    });
                }()),
                lightbox: function () {
                    if (typeof $.magnificPopup !== "object") {
                        return;
                    }

                    $(".lightbox:not(.lightbox--iframe)").magnificPopup({
                        mainClass: 'mfp-anim',
                        type: "image",
                        closeBtnInside: true,
                        removalDelay: 400,
                        callbacks: {
                            beforeOpen: function () {
                                if (this.st.el.attr('data-lightbox-class')) {
                                    this.st.mainClass = this.st.mainClass + " " + this.st.el.attr('data-lightbox-class');
                                }
                            }
                        }
                    });
                    $(".lightbox.lightbox--iframe").magnificPopup({
                        type: "iframe",
                        closeBtnInside: true
                    });
                    $(".lightbox.lightbox--inline").magnificPopup({
                        mainClass: 'mfp-anim',
                        closeBtnInside: true,
                        closeOnBgClick: false,
                        removalDelay: 400,
                        enableEscapeKey: false,
                        callbacks: {
                            beforeOpen: function () {
                                if (this.st.el.attr('data-lightbox-class')) {
                                    this.st.mainClass = this.st.mainClass + " " + this.st.el.attr('data-lightbox-class');
                                }
                            }
                        }
                    });
                },
                gallery: function (el) {
                    var $gallery = $(el);
                    var gallery = {
                        id: $gallery.data("gallery"),
                        img: $("img", el),
                        alt: ''
                    };

                    if (!$gallery.length || !gallery.id || typeof $.magnificPopup !== "object") {
                        return;
                    }

                    if (gallery.img.length && gallery.img.attr("alt")) {
                        gallery.alt = new RegExp(gallery.img.attr("alt").toLowerCase().replace("_", "-"));

                        if (!gallery.alt.test(gallery.img.attr("src"))) {
                            $gallery.attr("title", gallery.img.attr("alt"));
                        }
                    }

                    if (!galleries[gallery.id]) {
                        galleries[gallery.id] = [];
                    }
                    galleries[gallery.id].push($(el).parent()[0]);

                    $.each(galleries, function () {
                        $(this).magnificPopup({
                            mainClass: 'mfp-anim',
                            delegate: "a:visible",
                            type: "image",
                            closeBtnInside: true,
                            gallery: {
                                enabled: true
                            },
                            image: {
                                titleSrc: "title"
                            },
                            removalDelay: 400,
                            callbacks: {
                                beforeOpen: function () {
                                    if (this.st.el.attr('data-lightbox-class')) {
                                        this.st.mainClass = this.st.mainClass + " " + this.st.el.attr('data-lightbox-class');
                                    }
                                }
                            }
                        });
                    });
                },
                onready: function () {
                    app.lightbox.lightbox();

                    $("[data-gallery]", $content).each(function () {
                        app.lightbox.gallery(this);
                    });
                }
            };
        }()),
        popup: function () {
            var $popup = $("#popup");
            var $popup_inner = $(".popup__inner", $popup);
            var $bg = $("#bg");
            var $popup_bg = $("#popup_bg", $bg);

            $w.on("resize", function () {
                // $popup.css("height", $w.height());
            });

            $d.on("click.popup-close", ".js-popup-close", function(e) {
                $d.trigger({
                    type: "switch:close",
                    target: this
                }, "popup");

                $("html").css("overflow", "");
                if ($(".swiper-container", $bg).length) {
                    $(".swiper-container", $bg)[0].swiper.update();
                }

                $b.removeClass("popup--loaded");
                setTimeout(function () {
                    $(".foot__bg, .foot__bar", $footer).css("right", "");
                }, 100);

                if ($popup.data("xhr")) {
                    $popup.data("xhr").abort();
                }

                $popup_bg.data("timer", setTimeout(function() {
                    $popup_bg.css({"background-image": "", "background-position": ""});
                }, 500));

                e.preventDefault();
            });

            $("[data-popup]").on("click.popup-open", function (e) {
                var $this = $(this);

                clearTimeout($popup_bg.data("timer"));

                $("html").css("overflow", "hidden");
                if ($(".swiper-container", $bg).length) {
                    $(".swiper-container", $bg)[0].swiper.update();
                }

                $d.trigger({
                    type: "switch:open",
                    target: this
                }, "popup");

                if ($popup.data("xhr")) {
                    $popup.data("xhr").abort();
                }
                $popup.data("xhr", $.ajax({
                    url: saralove.ajaxurl,
                    type: "POST",
                    data: {
                        action: "theme_ajax",
                        type: "popup",
                        popup: $this.data("popup")
                    },
                    success: function (response) {
                        var image;
                        var scrollbar_width;

                        $("#popup_content", $popup).html(response.html);
                        scrollbar_width = $popup_inner[0].offsetWidth - $popup_inner[0].clientWidth;

                        if (response.image) {
                            image = new Image();
                            image.src = response.image;
                            image.onload = function () {
                                var css = {"background-image": "url(" + response.image + ")"};
                                if (response.position) {
                                    css["background-position"] = response.position;
                                }
                                $popup_bg.css(css);
                                $b.addClass("popup--loaded");
                                if (scrollbar_width) {
                                    setTimeout(function () {
                                        $(".foot__bg, .foot__bar", $footer).css("right", scrollbar_width);
                                    }, 280);
                                }
                            }
                        } else {
                            $b.addClass("popup--loaded");
                        }
                    }
                }));

                e.preventDefault();
            });
        },
        form: {
            item: function (item) {
                if ($(item).hasClass("form__item--select")) {
                    if (!$(".form__arrow", item).length) {
                        $("<span class=\"form__arrow\"></span>").insertAfter($("select", item));
                    }
                }
            },
            onready: function () {
                $(".form__item").each(function () {
                    app.form.item(this);
                });

                if (typeof $.fn.floatinglabel === "function") {
                    $(".floatinglabel").floatinglabel();
                }
            }
        },
        header: function () {
            $w.on("scroll.head-small", function () {
                var st = $w.scrollTop();
                var offset = parseInt($(".head__bar", $header).css("max-height"), 10);

                if (st >= offset && !app.vars.header_small) {
                    $header.addClass("head--small");
                    app.vars.header_small = true;
                } else if (st < offset && app.vars.header_small) {
                    $header.removeClass("head--small");
                    app.vars.header_small = false;
                }
            });

            if (typeof $.fn.headroom === "function") {
                $header.headroom({
                    offset: 50,
                    classes: {
                        pinned: 'head--pinned',
                        unpinned: 'head--unpinned',
                        top: 'head--top',
                        notTop: 'head--not-top',
                        bottom: 'head--bottom',
                        notBottom: 'head--not-bottom',
                        initial: 'head--headroom'
                    }
                });
            }
        },
        content: function () {
            (function () {
                var $page_full_height = $(".js-page-full-height", $content);

                if ($page_full_height.length) {
                    $w.on("resize", function () {
                        $("#whatsnew", $content).show();
                        $page_full_height.css("padding-top", $w.height()
                            - parseInt($content.css("padding-top"), 10)
                            - parseInt($content.css("padding-bottom"), 10)
                            - parseInt($(".page__inner", $page_full_height).css("padding-top"), 10)
                            - parseInt($(".page__inner", $page_full_height).css("padding-bottom"), 10)
                            - $(".page__content", $page_full_height).height()
                            - 40
                        );
                    });
                }
            }());
        },
        footer: function () {
        },
        popupalert: function () {
            var $popup_alert;
            var accepted;

            if (!app.cookie.get("agm") && translations.popup_alert) {
                $popup_alert = $("<div>", {
                    id: 'popup_alert',
                    class: 'popup-alert active',
                    html:
                        '<div class="popup-alert__bg"></div>' +
                        '<div class="popup-alert__inner">' +
                        '<div class="popup-alert__main">' +
                        '<div class="popup-alert__head">' +
                        '<h2><img src="' + saralove.logo + '" alt=""></h2>' +
                        '</div>' +
                        '<div class="popup-alert__content" data-active="1">' +
                        '<div class="popup-alert__item popup-alert__item--age">' +
                        '<h3>' + translations.popup_alert.age.head + '</h3>' +
                        '<p>' + translations.popup_alert.age.content + '</p>' +
                        '</div>' +
                        '<div class="popup-alert__item popup-alert__item--cookies">' +
                        '<h3>' + translations.popup_alert.cookies.head + '</h3>' +
                        '<p>' + translations.popup_alert.cookies.content + '</p>' +
                        '</div>' +
                        '</div>' +
                        '<div class="popup-alert__foot">' +
                        '<button class="btn btn--brd js-popup-alert-accept">' + translations.popup_alert.accept + '</button>' +
                        '<a href="about:blank" class="btn btn--stroke">' + translations.popup_alert.cancel + '</a>' +
                        '</div>' +
                        '</div>' +
                        '</div>'
                }).appendTo($b);

                accepted = $(".popup-alert__item", $popup_alert).length;

                $(".js-popup-alert-accept", $popup_alert).on("click", function (e) {
                    var active = parseInt($(".popup-alert__content", $popup_alert).attr("data-active"), 10);

                    if (accepted !== active) {
                        $(".popup-alert__content", $popup_alert).attr("data-active", active + 1);
                    } else {
                        app.cookie.set("agm", 1, 365);
                        $popup_alert.removeClass("active");
                    }

                    e.preventDefault();
                });
            }
        }
    };

    onready = function () {
        app.before();
        app.swiper.onready();
        app.lightbox.onready();
        app.popup();
        app.form.onready();
        app.header();
        app.content();
        app.footer();
        app.popupalert();
        app.after();

        $w.trigger("resize");
        $w.trigger("scroll");
    };
    onload = function () {
        window.loaded = true;
    };

    window.app = $.extend({}, window.app, {
        vars: app.vars,
        jrespond: app.jrespond,
        cookie: app.cookie,
        scrollto: app.scrollto,
        debounce: app.debounce,
        swiper: app.swiper.init,
        lightbox: {
            lightbox: app.lightbox.lightbox,
            gallery: app.lightbox.gallery
        },
        form: {
            item: app.form.item
        }
    });

    $(onready);
    $w.on("load", onload);

}(window, document, jQuery));